import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import i18n, {t} from "i18next";
import {
    createCopyLink,
    getImagePath,
    getImagePathSvg,
    getImagePathWithTheme,
    getImagePathWithThemeSvg,
    getItem,
    getLocalFilePath, getTimeText, imgPathPerfix, isAudio,
    isDarkMode, isObject, isStringNullOrEmpty
} from "../../../../../src/utils";
import {ConfigProvider, Dropdown, Input, Spin, Switch, message } from "antd";
import {
    IconCopyHighlight,
    IconCopyHighlight1,
    IconCopyLink,
    IconCopyText, IconDelete,
    IconEdit,
    IconExportHighlights, IconHomeSearch, IconInfoMenu, IconManagerTags
} from "../../../../../src/Icon";
import {postMessage} from "../../../../../src/common/event";
import {
    EVENT_TEST_ONDRAG_NOTE, FROM_DIALOG,
    FROM_HOME_DIALOG,
    KEY_TRANSCRIPT_AUTO_SCROLL, KEY_TRANSCRIPT_DIALOG_HAS_BANNER, KEY_TRANSCRIPT_IS_EXPAND,
    KEY_USE_SCROLL_WHEEL_ZOOM
} from "../../../../../src/Const";
import global from "../../../../../src/global";
import {getCardById, getTransctiptById, updateTranscript} from "../../../../../model";
import VideoTranscript from "./VideoTranscript";
import {importTranscriptFromContent} from "../../../../../src/VideoHighlightUtils";
import {useAtom} from "jotai";
import {atomTranscriptDialogHasBanner} from "../../../../../src/views/Home/HomeIndex";
import {sub} from "../../ga";

const TabHighlightTranscript = forwardRef((props:{elementVideoNotes:any,from:any,activeNote:any,clickOneNote:any,editNote:any,captureVideo:any,confirmNote:any,addNote:any,videoNotes:any,element:any,deleteNote:any,onClickTranscript:any,onQuickNote:any,onSearch:any,subFrom:any,type:any,onExpand:any,onHasTranscript:any,onExportCopyHighlight:any,onExportHighlightFile:any}, ref)=> {
    useImperativeHandle(ref,()=>({
        showImportTranscript:showImportTranscript,
        onScrollToTime:onScrollToTime
    }))
    const {elementVideoNotes,from,activeNote,clickOneNote,editNote,captureVideo,confirmNote,addNote,videoNotes,element,deleteNote,subFrom} = props;
    const [tabActive,setTableActive] = useState((isObject(props.element?.selectedId) && props.element?.selectedId?.type == 'transcript' && (props.subFrom != FROM_HOME_DIALOG || (props.subFrom == FROM_HOME_DIALOG) && isAudio(element.customData?.generationData.fileName)))?'transcript': 'highlights');
    const [arrayMoreMenus,setArrayMoreMenus] = useState([]);

    const videoNoteWrapperRef = useRef(null);
    const mSelectItem = useRef(null);
    const [arrayTranscript,setArrayTranscript] = useState<any>([]);
    const [isSearching,setIsSearching] = useState(false);
    const [searchKey,setSearchKey] = useState('');
    const [isAutoScroll,setIsAutoScroll] = useState(false);
    const [isSearch,setIsSearch] = useState(false);
    const [isExpand,setIsExpand] = useState(localStorage.getItem(KEY_TRANSCRIPT_IS_EXPAND) == 'true');
    const mSearchKey = useRef<any>('');
    const videoTranscriptRef = useRef(null);
    const inputSearchRef = useRef(null);
    const [transcript,setTranscript] = useState(null);
    const [hasArrayData,setHasArrayData] = useState(false);
    const[hasTranscriptBanner,setHasTranscriptBanner] = useAtom(atomTranscriptDialogHasBanner);

    const MORE_MENU = [
        getItem(i18n.t("Edit"), 'edit', <IconEdit/>, undefined, undefined, () => {
            editNote(mSelectItem.current)
        }),
        getItem(i18n.t("Copy link"), 'copyLink', <IconCopyLink/>, undefined, undefined, () => {
            createCopyLink("highlight", element.customData?.generationData?.id, 'videoNote', mSelectItem.current?.id);
        }),
        getItem(i18n.t("Show info"), 'showInfo', <IconInfoMenu/>, undefined, undefined, () => {
            getCardById(mSelectItem.current?.id)?.then(res => {
                window.showInfo('library',res);
            })
        }),
        getItem(i18n.t("Manage tags"), 'manageTags', <IconManagerTags/>, undefined, undefined, () => {
            getCardById(mSelectItem.current?.id)?.then(res => {
                window.showManageTags([res]);
            })
        }),
        getItem(i18n.t("Delete"), 'delete', <IconDelete/>, undefined, undefined, () => {
            window.showMessageBox(t("Tips"), t("SureDeleteHighlight"), t("Cancel"), t("Delete"), null, () => {
                deleteNote(mSelectItem.current);
            })
        }),
    ]

    const getArrayMoreMenus = ()=>{
        let moreMenus:any;
        if (tabActive == 'highlights'){
            moreMenus = [getItem(i18n.t("Copy highlight"), 'copyHighlight', <IconCopyHighlight1/>, undefined, undefined, () => {
                props.onExportCopyHighlight();
            }),
            getItem(i18n.t("Export highlight"), 'exportHighlight', <IconExportHighlights/>, undefined, undefined, () => {
                props.onExportHighlightFile();
            })]
        }else{
            moreMenus = [getItem(i18n.t("CopyEntireTranscript"), 'copyHighlight', <IconCopyHighlight1/>, undefined, undefined, () => {
                //导出字幕...
                videoTranscriptRef.current?.onExportTranscript();
            }),
                getItem(i18n.t("Export transcript"), 'exportHighlight', <IconExportHighlights/>, undefined, undefined, () => {
                    //导出字幕到文件...
                    videoTranscriptRef.current?.onExportTranscriptToFile();
                })]
        }

        return moreMenus;
    }


    useEffect(() => {
        setArrayMoreMenus(getArrayMoreMenus());
        setSearchKey('');
    }, [tabActive]);

    useEffect(() => {
        if (tabActive == 'highlights'){
            setHasArrayData(elementVideoNotes.length >0)
        }
    }, [elementVideoNotes]);

    useEffect(() => {
        if (props.onExpand){
            props.onExpand(isExpand);
        }
    }, [isExpand]);

    useEffect(() => {
        window.refreshList['show_transcript_in_dialog_'] = showTranscriptInDialog;

        return ()=>{
            delete window.refreshList['show_transcript_in_dialog_'];
        }
    },[props.onExpand]);


    useEffect(() => {
        const isAutoScroll = localStorage.getItem(KEY_TRANSCRIPT_AUTO_SCROLL) != 'false';
        setIsAutoScroll(isAutoScroll);

        if (props.type == 'dialogOnlyTranscript'){
            setTableActive('transcript');
        }

        //先取一遍，省得又刷新慢.
        getTransctiptById(props.element.customData?.generationData?.id).then(res=>{
            if (res){
                setTranscript(res);
            }
        })

        window.refreshList['switch_to_transcript_'] = switchToTranscript;


        return ()=>{
            delete window.refreshList['switch_to_transcript_'];
        }
    }, []);

    const switchToTranscript = ()=>{
        if (props.type == 'dialogOnlyTranscript'){
            setIsExpand(true);
            // props.onExpand(true);
        }else{
            setTableActive('transcript');
        }
    }

    const showTranscriptInDialog = ()=>{
        videoTranscriptRef.current?.refreshTranscript();
        setIsExpand(true);
        if (props.onExpand){
            props.onExpand(true);
        }
    }

    const showImportTranscript = ()=>{
        window.showDialogImportTranscript((file,content)=>{
            let arrayResults = importTranscriptFromContent(content);
            if (arrayResults && arrayResults.length > 0) {
                //保存....
                updateTranscript({id: props.element.customData?.generationData?.id, data: arrayResults}).then(res => {
                    window.globalRefreshList('refresh_transcript_');
                    switchToTranscript();
                });
            }
        })
    }

    const onScrollToTime = (lTime)=>{
        if (videoTranscriptRef.current && isAutoScroll){
            videoTranscriptRef.current?.onScrollToTime(lTime);
        }
    }

    /**
     * 渲染搜索后缀
     */
    const renderSuffix = ()=> {
        return <div className={'flex-row-vertical-center'}>
            {
                tabActive == 'transcript' &&
                <span className={'cursor-pointer default-font-size'} onClick={(e) => {
                    getTransctiptById(props.element.customData?.generationData?.id).then(res => {
                        if (res) {
                            window.showDialogReplace(searchKey, res, (newTranscript: any) => {
                                videoTranscriptRef.current?.refreshTranscript(searchKey);
                            });
                        }
                    })

                }}>{t('Replace')}</span>
            }

            <img className='img-mini-small-8 ml-12 cursor-pointer'
                 style={{}}
                 onClick={() => {
                     setIsSearch(false)
                     mSearchKey.current = '';
                     setSearchKey('')
                     if (tabActive == 'highlights') {
                         props.onSearch('', tabActive);
                     } else {
                         videoTranscriptRef.current?.onSearch('');
                     }
                 }}
                 src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>
        </div>
    }

    const hasFuncButton = () => {
        if (subFrom == FROM_HOME_DIALOG) {
            if (isAudio(element.customData?.generationData.fileName)) {
                return true;
            }
            return isExpand;
        }
        return true;
    }


    const hasMoreButton = ()=>{
        if (tabActive == 'highlights'){
            return elementVideoNotes.length > 0;
        }
        return hasArrayData && hasFuncButton();
    }

    return <div className={'tab-highlight-transcript'}
                style={{
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    height: (isAudio(element.customData?.generationData.fileName) && subFrom == FROM_HOME_DIALOG) ? 'calc(100% - 12px)' : '100%',
                    position: 'relative'
                }}>

        {
            //这里是对话框弹窗的，如果没有transcript，也没有过关闭需要显示的这部分东西
        !hasArrayData && props.type == 'dialogOnlyTranscript' && hasTranscriptBanner && !isSearch &&
            <div className={'flex-row-vertical-center default-font-family default-font-size'} style={{minHeight:'40px',height:'40px',background:'var(--video-transcript-tip-background-color)',padding:'0 16px'}}>
                <img className={'img-14'} src={getImagePathWithThemeSvg('video_transcript_tip.svg')}/>
                <span className={'ml-6'}>{t("MakeTheVideosSearchable")}</span>
                <span className={'cursor-pointer ml-6'} style={{color:'var(--primary-color)'}} onClick={(e)=>{
                    showImportTranscript();
                }}>{t("ImportSrtTranscript")}</span>
                <img className={'cursor-pointer img-14 ml-6'} style={{marginLeft:'auto'}} src={getImagePathWithThemeSvg('close_again_0')} onClick={(e)=>{
                    localStorage.setItem(KEY_TRANSCRIPT_DIALOG_HAS_BANNER,'false');
                    setHasTranscriptBanner(false);
                }}/>
            </div>
        }

        {
            isSearch ? <Input ref={inputSearchRef} prefix={<IconHomeSearch/>} id={'input-library-search-1'}
                              suffix={renderSuffix()}
                              variant={"borderless"}
                              style={{
                                  width: 'calc(100% - 0px)',
                                 height: '30px',
                                  marginTop:'6px',
                                 backgroundColor: 'var(--video-transcript-search-background)',
                             }}
                             placeholder={tabActive == 'highlights'?t("Search highlights"):t('Search transcript')} value={searchKey} onChange={(event) => {
                    setSearchKey(event.currentTarget.value);
                    let szSearchKey = event.currentTarget.value.toLowerCase();
                    if (tabActive == 'highlights'){
                        props.onSearch(szSearchKey,tabActive);
                    }else {
                        videoTranscriptRef.current?.onSearch(szSearchKey);
                    }
                }}/>:
                <div className={'flex-row-vertical-center'} style={{marginTop: (from == 'slider') ? '6px' : `${props.type == 'dialogOnlyTranscript'?'10px':'0'}`,minHeight: '30px',paddingRight:subFrom == FROM_HOME_DIALOG?'10px':'0px'}}>
                    {
                        <>
                            {
                                props.type != 'dialogOnlyTranscript' &&
                                <span
                                    style={{color: tabActive == 'highlights' ? 'var(--text-color)' : 'var(--text-color-bab8b8)'}}
                                    className={'highlight-title cursor-pointer'} onClick={(e) => {
                                    setTableActive('highlights');
                                    setHasArrayData(elementVideoNotes.length > 0);
                                }}>{i18n.t("Highlights") + ' ' + (elementVideoNotes.length > 0 ? `(${elementVideoNotes.length})` : '')}</span>
                            }

                            {
                                props.type == 'dialogOnlyTranscript' &&
                                <img className={'img-12 cursor-pointer'} style={{transform: isExpand ? 'rotate(0deg)' : 'rotate(-90deg)',}} src={getImagePathWithThemeSvg('transcript_dropdown')} onClick={(e)=>{
                                        setIsExpand(!isExpand);
                                    localStorage.setItem(KEY_TRANSCRIPT_IS_EXPAND,!isExpand?'true':'false')
                                        // props.onExpand(!isExpand);
                                }}/>
                            }

                            {
                                (props.from == 'slider' || props.type == 'dialogOnlyTranscript') &&
                                <span style={{
                                    marginLeft: props.type == 'dialogOnlyTranscript'?'2px':'16px',
                                    color: tabActive == 'transcript' ? 'var(--text-color)' : 'var(--text-color-bab8b8)'
                                }}
                                      className={'highlight-title cursor-pointer'} onClick={(e) => {
                                          if (props.type == 'dialogOnlyTranscript'){
                                              setIsExpand(!isExpand);
                                              localStorage.setItem(KEY_TRANSCRIPT_IS_EXPAND,!isExpand?'true':'false')
                                              // props.onExpand(!isExpand);
                                          }else{
                                              setTableActive('transcript');
                                          }
                                }}>{i18n.t("Transcript") + ' ' + (arrayTranscript.length > 0 ? `(${arrayTranscript.length})` : '')}</span>
                            }
                        </>
                    }

                    {
                        //有标注或者翻译的时候才有操作按钮
                        hasMoreButton() &&
                        <div className={'flex-row-vertical-center transcript-operator default-font-family default-font-size'} style={{marginLeft: 'auto'}}>
                            {
                                tabActive == 'transcript' &&
                                <>
                                    <span>{i18n.t('Auto scroll')}</span>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Switch: {
                                                    /* 这里是你的组件 token */
                                                    handleSize: 12,
                                                    trackHeight: '16px',
                                                    trackMinWidth: '30px',
                                                },
                                            },
                                        }}
                                    >
                                        <Switch value={isAutoScroll} style={{width: '32px', marginLeft: '8px',}}
                                                onChange={(e) => {
                                                    setIsAutoScroll(e);
                                                    if (e) {
                                                        localStorage.setItem(KEY_TRANSCRIPT_AUTO_SCROLL, 'true');
                                                    } else {
                                                        localStorage.removeItem(KEY_TRANSCRIPT_AUTO_SCROLL);
                                                    }
                                                }}/>
                                    </ConfigProvider>
                                </>
                            }


                            <img className={'img-16 cursor-pointer ml-16'}
                                 src={getImagePathWithThemeSvg('video_search_1')} onClick={(e) => {
                                setIsSearch(true);
                                setTimeout(() => {
                                    inputSearchRef.current?.focus();
                                }, 200);
                            }}/>

                            <Dropdown menu={{items: arrayMoreMenus}} trigger={["click"]}
                                      overlayStyle={{minWidth: '220px'}}>
                                <img className={'img-16 cursor-pointer ml-16'}
                                     src={getImagePathWithThemeSvg('video_more_1')}/>
                            </Dropdown>
                        </div>
                    }
                </div>
        }

        {
            props.type != 'dialogOnlyTranscript' &&
            <div style={{height: '16px'}}></div>
        }


        <div id={'div-local-video-note-container'} className="video-note-wrapper" ref={videoNoteWrapperRef}>

            {
                tabActive == 'highlights' ? <>
                    <div className={''} style={{overflow: 'auto', height: 'calc(100% - 0px)', width: '100%'}}>
                        {elementVideoNotes.map((item, index) => {
                            if (!item) return <></>
                            const {id, title, time, content} = item;
                            const getClassName = () => {
                                if (`${activeNote?.id}` == `${id}`) {
                                    return "one-note one-note-acitve";
                                }
                                return "one-note";
                            }
                            return (
                                <Dropdown /*open={isContextMenuOpen}*/ menu={{items: MORE_MENU}}
                                                                       overlayClassName={'default-dropdown-style'}
                                                                       trigger={["contextMenu"]}
                                                                       onOpenChange={(e) => {
                                                                           if (global.g_isPresentMode) {
                                                                               // setIsContextMenuOpen(false);
                                                                               return;
                                                                           }
                                                                           if (e) {
                                                                               mSelectItem.current = item;
                                                                           }
                                                                           // setIsContextMenuOpen(e);
                                                                       }}>
                                    <div
                                        id={'div-video-note-item-' + item.id}
                                        draggable={true}
                                        style={{marginRight: (from == 'slider') ? '0px' : '0px'}}
                                        className={
                                            getClassName()
                                        }
                                        key={id}
                                        onClick={() => {
                                            clickOneNote(item);
                                        }}

                                        onDoubleClick={() => {
                                            clickOneNote(item);
                                            editNote(item);
                                        }}

                                        onMouseDown={(event) => {
                                            event.stopPropagation();
                                            // event.preventDefault();
                                        }}

                                        onDragEnd={(event: any) => {
                                            if (global.g_isPresentMode) return;

                                            const dragData = {
                                                id: item.id,
                                                libraryId: videoNotes.element?.customData?.generationData?.id,
                                                fileName: videoNotes.element?.customData?.generationData?.fileName,
                                                videoData: item,
                                                name: element.name,
                                                type: 'videoAnno',
                                                x: event.clientX,
                                                y: event.clientY
                                            }
                                            postMessage(EVENT_TEST_ONDRAG_NOTE, dragData);
                                            if (window.location.href.endsWith("/card") || window.location.href.endsWith('/journal') || window.location.href.endsWith('/draw') || window.location.href.endsWith('/defaultProject')) {
                                                global.g_currentDragLibraryItem = {...dragData};
                                            }
                                            event.stopPropagation();

                                        }}>

                                        <div className="one-header">
                                            <div className="one-header-left">
                                                <img className={'img-12'} src={getImagePathWithTheme('mini_time')}/>
                                                <span className={'ml-4 font-size-10'}
                                                      style={{color: isDarkMode() ? '#BAB8B8' : 'var(--color-666666)'}}>{getTimeText(time)}</span>
                                                {
                                                    item.endTime > 0 &&
                                                    <span className={'font-size-10'}
                                                          style={{color: isDarkMode() ? '#BAB8B8' : 'var(--color-666666)'}}>{'-' + getTimeText(item.endTime)}</span>
                                                }
                                                {
                                                    item.loop &&
                                                    <img className={'img-12 ml-4'}
                                                         src={getImagePathWithTheme('video_loop')}/>
                                                }
                                            </div>

                                            <div className="one-header-right"
                                                 style={{display: global.g_isPresentMode ? 'none' : 'inherit'}}>
                                                <img className={'img-16'}
                                                     src={getImagePathWithTheme('video_note_edit')}
                                                     onClick={(e) => {
                                                         e.stopPropagation();
                                                         editNote(item);
                                                     }}
                                                />
                                                <Dropdown overlayClassName={'default-dropdown-style'}
                                                          menu={{items: MORE_MENU}} trigger={["click"]}
                                                          onOpenChange={(e) => {

                                                          }}>
                                                    <img className={'img-16 ml-10'}
                                                         src={getImagePathWithTheme('video_note_more')}
                                                         onClick={(e) => {
                                                             e.stopPropagation();
                                                             mSelectItem.current = item;
                                                         }}/>
                                                </Dropdown>
                                                {/*<img className={'img-28'} src={getImagePathWithTheme('video_note_delete')}*/}
                                                {/*     onClick={(e) => {*/}
                                                {/*         e.stopPropagation();*/}
                                                {/*         window.showMessageBox(t("Tips"), t("SureDeleteHighlight"), t("Cancel"), t("Delete"), null, () => {*/}
                                                {/*             deleteNote(item);*/}
                                                {/*         })*/}
                                                {/*     }}*/}
                                                {/*/>*/}
                                            </div>
                                        </div>
                                        <div className={'flex-row mt-8'}>
                                            <div>
                                                <div className="one-title">
                                                  <span className={'font-family-medium'}
                                                        style={{fontSize: '14px'}}>{title}</span>
                                                </div>
                                                <span
                                                    className={(!item.title && item.thumbImage) ? "one-note-content-3" : "one-note-content"}>{content}</span>
                                            </div>
                                            {
                                                item.thumbImage &&
                                                <>
                                                    {/*<div style={{width:'12px'}}></div>*/}
                                                    <img className={'cursor-pointer'} style={{
                                                        width: '104px',
                                                        height: item.title ? '62px' : '58px',
                                                        flexShrink: '0',
                                                        marginLeft: 'auto',
                                                        marginTop: '3px',
                                                        borderRadius: '8px',
                                                        objectFit: 'cover'
                                                    }} src={getLocalFilePath(item.thumbImage, false)}
                                                         onClick={(event) => {
                                                             event.stopPropagation();
                                                             window.showImagePreviewWithFullUrl(getLocalFilePath(item.thumbImage, false))
                                                         }} onDoubleClick={(event) => {
                                                        event.stopPropagation();
                                                    }}/>
                                                </>
                                            }
                                        </div>
                                    </div>
                                </Dropdown>
                            );
                        })}
                    </div>
                    {
                        !global.g_isPresentMode &&
                        <>
                            <div style={{marginLeft: '-16px', marginRight: '-16px'}} className={'line'}></div>
                            <div className="video-note-bottom">
                                <div className={'button-border-style flex-center border-radius-8 cursor-pointer'}
                                     style={{
                                         height: '40px',
                                         flexGrow: '1',
                                         background: 'var(--primary-color)',
                                         // border: isDarkMode() ? '1px solid #3670F7C4' : '1px solid var(--button-background-color)'
                                     }} onClick={addNote}>
                                    <img className={'img-16'} src={getImagePathSvg('add_highlight_white')}/>
                                    <span className={'ml-4'}
                                          style={{color: '#FFFFFF'}}>{i18n.t("Add highlight")}</span>
                                </div>

                                <div className={'button-border-style flex-center border-radius-8 cursor-pointer'}
                                     style={{
                                         height: '40px',
                                         flexGrow: '1',
                                         background: '#17A34A',
                                         border: 'none',
                                         // border: isDarkMode() ? '1px solid #3670F7C4' : '1px solid var(--button-background-color)'
                                     }} onClick={async () => {
                                    await captureVideo(true);
                                    setTimeout(() => {
                                        confirmNote(true);
                                        message.destroy();
                                        message.info(t("Highlight saved"))
                                    }, 100)
                                }}>
                                    <img className={'img-16'} src={getImagePath('quick_note_white')}/>
                                    <span className={'ml-6'}
                                          style={{color: '#FFFFFF'}}>{i18n.t("Quick note")}</span>
                                </div>
                            </div>
                        </>
                    }


                    {
                        elementVideoNotes.length == 0 &&
                        <span className={'video-note-wrapper-no-data'}
                              style={{color: isDarkMode() ? '#BAB8B8' : 'var(--color-9A9A9A)'}}>{i18n.t(isAudio(element.customData?.generationData.fileName) ? "No audio notes" : "No video notes")}</span>
                    }
                </> : <VideoTranscript ref={videoTranscriptRef} element={element} from={from} subFrom={subFrom} onShowImportTranscript={showImportTranscript} type={props.type} transcriptData={transcript} onClickItem={(item,isAutoPlay)=>{
                    //转到这个时间...
                    props.onClickTranscript(item,isAutoPlay);
                }} onQuickNote={async (item)=>{
                    props.onQuickNote(item);
                }} onExpand={(e)=>{
                    // setIsExpand(e);
                    // if (props.onExpand){
                    //     props.onExpand(e);
                    // }
                }} onHasTranscript={(e)=>{
                    if (props.onHasTranscript){
                        props.onHasTranscript(e);
                    }
                }} onGetData={(transcript)=>{
                    if (transcript){
                        setHasArrayData(transcript.data.length >0);
                    }else{
                        setHasArrayData(false);
                    }
                }} />
            }
        </div>
    </div>
})

export default TabHighlightTranscript;